import React from "react";
import Box from "react-raster";
import { Heading, Icon, IconId, icons, Tooltip} from "src/components";
import { theme } from "src/config";
import { Colors } from "src/types";

export const IconSection = () => {
  return (
    <Box gridRowGap={theme.layout.gutterSmall}>
            <Heading weight="normal" type="h3" color="black">Icons</Heading>
      <Box>
        <hr />
      </Box>
      <Box display="flex" flexWrap="wrap" rowGap="1rem" columnGap="1rem"> 
      {Object.keys(icons).map((i: IconId) => (
          <Tooltip content={i} key={i}>
            <Icon iconId={i} size="large" color={theme.color.black}/>
          </Tooltip>
        ))}
      </Box>
    </Box>
  );
};
